export default __webpack_public_path__ + "static/media/571.5433247a.png";